import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://ucsxdqiadzllgwsydjkv.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVjc3hkcWlhZHpsbGd3c3lkamt2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg5MzkzNjgsImV4cCI6MjA4NDUxNTM2OH0.UCgljprxEG9qOQptUqaWVHPfjLZmOTpkUBfxGNgbvyI';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});
